<mat-paginator
  [length]="totalItems"
  [pageSizeOptions]="pageSizeOptions"
  [pageSize]="itemsPerPage"
  [pageIndex]="currentPage"
  (page)="changePage($event)"
  [showFirstLastButtons]="true">
</mat-paginator>
